import { useProtectedAPI } from "./apiService";
import { objectToQueryString } from "@/utils/objectToQueryString";
import useSWR from "swr";



export const useGetForumsGroups= () => {
    const protectedAPI = useProtectedAPI()

    const getForumsGroups = async () => {
        const url = `/forums/groups`
        const response = await protectedAPI.get(url)
        return response.data
    }
    
    return getForumsGroups
}

/* Admin */


export const useAdminGetForumGroupsSWR = () => {

    const protectedApi = useProtectedAPI();
    const fetcher = (url) => protectedApi.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR("/admin/forum_groups", fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useAdminGetForumGroups = () => {
    const protectedAPI = useProtectedAPI()

    const adminGetForums = (filters) => {
        const queryString = objectToQueryString(filters)
        const url = `/admin/forum_groups?${queryString}`
        const promise = protectedAPI.get(url).then(response => {
            return {
                data: response.data,
                total: response.headers["x-total-count"]
            }
        })

        return {
            then: (resolve, reject) =>
                promise.then(result => resolve(result.data), reject),
            catch: (reject) =>
                promise.catch(reject),
            withTotal: () =>
                promise.then(result => [result.data, result.total])
        }
    }
    
    return adminGetForums
}



export const useAdminGetForumGroup = () => {
    const protectedAPI = useProtectedAPI()

    const adminGetForum = async (id) => {
        const response = await protectedAPI.get(`/admin/forum_groups/${id}`)
        return response.data
    }

    return adminGetForum
}



export const useAdminCreateForumGroup = () => {
    const protectedAPI = useProtectedAPI();

    const adminCreateForum = async (data) => {
        const response = await protectedAPI.post(`/admin/forum_groups`, data)
        return response.data
    };

    return adminCreateForum;
}



export const useAdminUpdateForumGroup = () => {
    const protectedAPI = useProtectedAPI();

    const adminUpdateForum = async (id, data) => {
        const response = await protectedAPI.put(`/admin/forum_groups/${id}`, data)
        return response.data
    };

    return adminUpdateForum;
}



export const useAdminDeleteForumGroup = () => {
    const protectedAPI = useProtectedAPI();

    const adminDeleteForum = async (id) => {
        const response = await protectedAPI.delete(`/admin/forum_groups/${id}`)
        return response.data
    };

    return adminDeleteForum;
}
